import { render, staticRenderFns } from "./worker-settings.vue?vue&type=template&id=1d21f9ae&scoped=true"
import script from "./worker-settings.vue?vue&type=script&lang=js"
export * from "./worker-settings.vue?vue&type=script&lang=js"
import style0 from "./worker-settings.vue?vue&type=style&index=0&id=1d21f9ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d21f9ae",
  null
  
)

export default component.exports